import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import GradeReport from "../../CcpSchool/CcpSchoolReports/inc/GradeReport";

const DistrictGradeReport = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>Grade Report</ModalDialogTitle>
      <DialogContent>
        <GradeReport schoolId={schoolId} />
      </DialogContent>
    </Dialog>
  );
};

export default DistrictGradeReport;
